/**
 * Chargeback-specific constants
 *
 * Entry types and stakeholder types as returned by the chargeback backend.
 * These use UPPERCASE naming (different from the general accounting constants).
 */

// Entry types (backend returns lowercase)
export const ENTRY_TYPES = {
    REVENUE: 'revenue',
    FEE: 'fee',
    COST: 'cost',
    DISPUTE_FEE: 'dispute_fee',
    HANDLING_FEE: 'handling_fee',
}

export const ENTRY_TYPE_LABELS = {
    [ENTRY_TYPES.REVENUE]: 'Revenue',
    [ENTRY_TYPES.FEE]: 'Fee',
    [ENTRY_TYPES.COST]: 'Cost',
    [ENTRY_TYPES.DISPUTE_FEE]: 'Dispute Fee',
    [ENTRY_TYPES.HANDLING_FEE]: 'Handling Fee',
}

// Dispute statuses (from Stripe)
export const DISPUTE_STATUSES = {
    WARNING_NEEDS_RESPONSE: 'warning_needs_response',
    WARNING_UNDER_REVIEW: 'warning_under_review',
    WARNING_CLOSED: 'warning_closed',
    NEEDS_RESPONSE: 'needs_response',
    UNDER_REVIEW: 'under_review',
    WON: 'won',
    LOST: 'lost',
}

export const DISPUTE_STATUS_LABELS = {
    [DISPUTE_STATUSES.WARNING_NEEDS_RESPONSE]: 'Warning - Needs Response',
    [DISPUTE_STATUSES.WARNING_UNDER_REVIEW]: 'Warning - Under Review',
    [DISPUTE_STATUSES.WARNING_CLOSED]: 'Warning - Closed',
    [DISPUTE_STATUSES.NEEDS_RESPONSE]: 'Needs Response',
    [DISPUTE_STATUSES.UNDER_REVIEW]: 'Under Review',
    [DISPUTE_STATUSES.WON]: 'Won',
    [DISPUTE_STATUSES.LOST]: 'Lost',
}

export const DISPUTE_STATUS_COLORS = {
    [DISPUTE_STATUSES.WARNING_NEEDS_RESPONSE]: 'warning',
    [DISPUTE_STATUSES.WARNING_UNDER_REVIEW]: 'warning',
    [DISPUTE_STATUSES.WARNING_CLOSED]: 'secondary',
    [DISPUTE_STATUSES.NEEDS_RESPONSE]: 'danger',
    [DISPUTE_STATUSES.UNDER_REVIEW]: 'info',
    [DISPUTE_STATUSES.WON]: 'success',
    [DISPUTE_STATUSES.LOST]: 'danger',
}

// Stakeholder types (backend returns these values)
export const STAKEHOLDER_TYPES = {
    PICA: 'pica',
    PHOTO_SERVICE: 'photo_service',
    ORGANIZER: 'organizer',
}

export const STAKEHOLDER_TYPE_LABELS = {
    [STAKEHOLDER_TYPES.PICA]: 'Pica',
    [STAKEHOLDER_TYPES.PHOTO_SERVICE]: 'Photo Service',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'Organizer',
}

export const STAKEHOLDER_TYPE_COLORS = {
    [STAKEHOLDER_TYPES.PICA]: 'primary',
    [STAKEHOLDER_TYPES.PHOTO_SERVICE]: 'info',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'success',
}

/**
 * Normalize a chargeback entry for use with LedgerEntriesTable.
 */
export function normalizeEntry(entry) {
    return {
        ...entry,
        currency: 'EUR',
    }
}
